import type { AjaxObject } from "@rootreeweb/plugin-lib";

export interface PSPR_Product_ajax_obj extends AjaxObject {
	payload: {
		translations: { [key: string]: string };
	};
}
declare const rtpspr_PSPR_Product_ajax_obj: PSPR_Product_ajax_obj;

/**
 * Get the translation for the given key in the lookup.
 *
 * @param key The key to look up.
 * @returns The translation.
 */
export function getTranslation(key: string): string {
	const { payload } = rtpspr_PSPR_Product_ajax_obj;
	return payload.translations[key] || "";
}
